import { requests } from '../../helper/agent';
import { SubmissionError } from 'redux-form';
import { CCSD_CODE_TYPE_LIST_REQUEST, CCSD_CODE_TYPE_LIST_RECEIVED, CCSD_CODE_TYPE_LIST_ERROR } from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';
import { parseApiErrors } from '../../helper/apiUtils';

export const ccsdCodeTypeListRequest = () => ({
  type: CCSD_CODE_TYPE_LIST_REQUEST,
});

export const ccsdCodeTypeListReceived = (data) => ({
  type: CCSD_CODE_TYPE_LIST_RECEIVED,
  data,
});

export const ccsdCodeTypeListError = (error) => ({
  type: CCSD_CODE_TYPE_LIST_ERROR,
  error,
});

export const ccsdCodeTypeListFetch = () => {
  return (dispatch) => {
    dispatch(ccsdCodeTypeListRequest());
    const filters = { pagination: false };
    return requests
      .get(API_ROUTES.CCSD_CODE_TYPE, filters)
      .then((response) => dispatch(ccsdCodeTypeListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        } else if (error.response && error.response.status === 403) {
          return new SubmissionError(parseApiErrors({ _error: 'You are not allowed to do this.' }));
        }
        dispatch(ccsdCodeTypeListError(error));
      });
  };
};
